import { FormField, Select } from 'grommet';
import type { ContactPreferenceProps } from '@customTypes/types';
import type { ContactPreferenceState } from '@customTypes/stateTypes';
import { useReducer } from 'react';

const contactPreferenceOptions: string[] = [
  'Email',
  'Phone',
];

export const ContactPreference = (props: ContactPreferenceProps): JSX.Element => {
  const [state, updateState] = useReducer(
    (prev: ContactPreferenceState, newState: Partial<ContactPreferenceState>) => ({
      ...prev,
      ...newState,
    }),
    {
      contactPreference: ''
    }
  )

  const onPreferredContactChange = (option: string): void => {
    updateState({ contactPreference: option })
  }

  const clearState = () => {
    updateState({
      contactPreference: ''
    });
  }

  props.onReset && props.onReset(clearState);

  return (
    <FormField
      name="selectContact"
      htmlFor="select-contact"
      label="How would you prefer to be contacted?"
      required
    >
      <Select
        id="select-contact"
        name="selectContact"
        placeholder="Select"
        value={state.contactPreference || props.contactPreference}
        options={contactPreferenceOptions}
        onChange={({option}) => onPreferredContactChange(option)}
      />
    </FormField>
  );
};
